import React, { useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import axios from "axios";
import BookingTimeline from "@/components/BookingTimeline";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TrackingPage() {
  const { token } = useParams();
  const [sp] = useSearchParams();
  const sessionId = sp.get("session_id") || "";
  const justPaid = sp.get("paid") === "1";

  // Reconcile the booking after Stripe redirects the customer back here
  // with `?paid=1&session_id=...`. Triggers the driver "Paiement reçu"
  // push and unlocks his «Course terminée» button — works even when the
  // production Stripe webhook has not been configured yet.
  useEffect(() => {
    if (!justPaid || !sessionId) return;
    let cancelled = false;
    let attempts = 0;
    (async () => {
      while (!cancelled && attempts < 6) {
        try {
          const { data } = await axios.get(`${API}/payments/status/${sessionId}`);
          if (data?.payment_status === "paid") return;
        } catch (_) {}
        attempts += 1;
        await new Promise((r) => setTimeout(r, 1500));
      }
    })();
    return () => { cancelled = true; };
  }, [justPaid, sessionId]);

  return (
    <div className="min-h-screen bg-secondary/30 bg-grain" data-testid="tracking-page">
      <header className="border-b border-border/60 bg-background/80 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-3xl items-center gap-2.5 px-6">
          <div className="relative h-8 w-8 rounded-full bg-primary grid place-items-center">
            <span className="font-[Outfit] text-lg font-light text-primary-foreground">S</span>
            <span className="absolute -right-0.5 -bottom-0.5 h-2.5 w-2.5 rounded-full bg-accent" />
          </div>
          <span className="font-[Outfit] text-xl">Saor</span>
          <span className="ml-auto text-xs text-muted-foreground">Suivi de course</span>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10">
        <div className="rounded-2xl border border-border bg-card p-8 shadow-sm">
          <h1 className="mb-5 font-[Outfit] text-3xl font-normal tracking-tight">Votre course Saor</h1>
          <BookingTimeline token={token} showTimeline={false} showCancel={true} />
        </div>

        <p className="mt-6 text-center text-xs text-muted-foreground">
          Besoin d'aide ? Contactez l'équipe Price — contact@pricecovoit.fr
        </p>
      </main>
    </div>
  );
}
